import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { EnlistedDashboard, NCODashboard, WarrantDashboard, OfficerDashboard, CommandDashboard } from './dashboards';
import { Shield, RefreshCw } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function CommandCenter({ user }) {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const rankLevel = user?.rank?.level || 1;

  const getDashboardEndpoint = useCallback(() => {
    if (rankLevel === 5) return '/dashboard/command';
    if (rankLevel === 4) return '/dashboard/officer';
    if (rankLevel === 3) return '/dashboard/warrant';
    if (rankLevel === 2) return '/dashboard/nco';
    return '/dashboard/enlisted';
  }, [rankLevel]);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        setLoading(true);
        setError(null);
        const endpoint = getDashboardEndpoint();
        const response = await axios.get(`${API}${endpoint}`);
        setDashboardData(response.data);
      } catch (err) {
        console.error('Failed to fetch dashboard:', err);
        setError('Failed to load dashboard data');
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
    const interval = setInterval(fetchDashboard, 60000);
    return () => clearInterval(interval);
  }, [getDashboardEndpoint]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-64" data-testid="dashboard-loading">
        <div className="spinner mb-4"></div>
        <p className="text-cyan-400 text-sm tracking-wider animate-pulse">LOADING DASHBOARD...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-64" data-testid="dashboard-error">
        <div className="text-center glass-panel p-8">
          <Shield className="w-12 h-12 text-red-400 mx-auto mb-4" />
          <p className="text-red-400 text-lg mb-4">{error}</p>
          <button 
            onClick={() => window.location.reload()} 
            className="btn-primary flex items-center gap-2 mx-auto"
          >
            <RefreshCw size={16} />
            RETRY CONNECTION
          </button>
        </div>
      </div>
    );
  }

  if (rankLevel === 5) return <CommandDashboard data={dashboardData} user={user} />;
  if (rankLevel === 4) return <OfficerDashboard data={dashboardData} user={user} />;
  if (rankLevel === 3) return <WarrantDashboard data={dashboardData} user={user} />;
  if (rankLevel === 2) return <NCODashboard data={dashboardData} user={user} />;
  return <EnlistedDashboard user={user} data={dashboardData} />;
}

export default CommandCenter;
